export class IsoField {
  public isSelected!: boolean
  public fieldId!: number
  public fieldNumber!: string
  public value!: string
  public description!: string
}
